import React, { useMemo, useCallback, memo } from 'react';
import { useParams } from 'react-router-dom';
import { Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Logo } from '@kinetic-ui/shared/lib/assets/qfree-logo.svg';
import { useCameraQuery } from '@kinetic-ui/data-layer';
import {
  ExtendedVideoPlayer,
  VideoPlayerFunctionality,
  VideoPlayerCamera,
  CAMERA_DETAIL_ROUTE,
} from '@kinetic-ui/shared';

import useCameraPlayerPageStyles from './styles';

const playerFunctionalities = [
  VideoPlayerFunctionality.PUBLIC_FEED,
  VideoPlayerFunctionality.CAMERA_LOCK,
  VideoPlayerFunctionality.CAPABILITIES,
  VideoPlayerFunctionality.FOCUS_CONTROL,
  VideoPlayerFunctionality.IRIS_CONTROL,
  VideoPlayerFunctionality.PRESET_CONTROL,
  VideoPlayerFunctionality.PTZ,
  VideoPlayerFunctionality.RECORDING,
  VideoPlayerFunctionality.SCREEN_LAYOUT_CONTROL,
  VideoPlayerFunctionality.SETTINGS,
];

const CameraPlayerPage: React.FunctionComponent = () => {
  const { id } = useParams<{ id: string }>();
  const classes = useCameraPlayerPageStyles();

  const { t } = useTranslation('app');

  const cameraResult = useCameraQuery({
    fetchPolicy: 'cache-and-network',
    variables: { id },
  });

  const camera = useMemo(() => cameraResult.data?.camera, [cameraResult.data?.camera]);

  const refetchCamera = useCallback(() => {
    cameraResult.refetch({ id });
  }, [cameraResult, id]);

  return (
    <div className={classes.cameraPlayerPageWrapper}>
      <Toolbar variant='dense' className={classes.toolbar} disableGutters>
        <Logo className={classes.logo} viewBox='23 12 154 55' display='inline-flex' />
        <Typography variant='body1' noWrap>
          {t('kineticMobility')}
        </Typography>
      </Toolbar>
      <div className={classes.cameraPlayerWrapper}>
        {camera && (
          <ExtendedVideoPlayer
            videoPlayerFunctionalities={playerFunctionalities}
            camera={camera as VideoPlayerCamera}
            refetchData={() => refetchCamera()}
            cameraDetailRoute={`${CAMERA_DETAIL_ROUTE}/${camera.id}`}
          />
        )}
      </div>
    </div>
  );
};

export default memo(CameraPlayerPage);
